import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_ds_get_inventory_by_licenseplate_lot_packagingService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licensePlateId?: number, lotId?: number, packagingId: number, materialId: number, vendorLotId?: number, locationId?: number, warehouseId: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, AvailablePackagedAmount?: number, TotalAmount?: number, TotalPackagedAmount?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.packagingId)) {
      missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_by_licenseplate_lot_packaging/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { licensePlateId?: number, lotId?: number, packagingId: number, materialId: number, vendorLotId?: number, locationId?: number, warehouseId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, AvailablePackagedAmount?: number, TotalAmount?: number, TotalPackagedAmount?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.packagingId)) {
      missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_by_licenseplate_lot_packaging/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { licensePlateId?: number, lotId?: number, packagingId: number, materialId: number, vendorLotId?: number, locationId?: number, warehouseId: number, $keys: { LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, AvailablePackagedAmount?: number, TotalAmount?: number, TotalPackagedAmount?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.packagingId)) {
      missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_get_inventory_by_licenseplate_lot_packaging/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      licensePlateId?: number, lotId?: number, packagingId: number, materialId: number, vendorLotId?: number, locationId?: number, warehouseId: number    }) {
        if(isNil(inParams.packagingId)) {
          return true; 
        }
        if(isNil(inParams.materialId)) {
          return true; 
        }
        if(isNil(inParams.warehouseId)) {
          return true; 
        }
      return false;
    }
}
